<div class="row">
<div class="col-md-4">
  <mat-card>
    <div class="main">  
  <div class="row">
      <div class="col-md-8">    <h2>Customer</h2></div> 
    <div class="col-md-4 view"> </div>
    <!-- <a href="">View Details</a> -->
    </div> </div>
    <mat-divider></mat-divider>
    <div class="container container-table">
      <br>
      <div class="text-center">
      <img *ngIf="order.customers.image.url!='' && order.customers.image.url!=undefined;else staticImg" src="{{order.customers.image.url}}" class="rounded-circle profile" alt="Cinque Terre">
      <ng-template #staticImg> <img  src="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png" class="rounded-circle profile" alt="Cinque Terre"></ng-template>
      <br>
      <p class="customerName">{{order.customers.fullname}}</p>
      <p class="customeremail">
    {{order.customers.email}}</p>
   +{{order.customers.countryCode}} {{order.customers.phone}}
  <br>
   <ngb-rating [(rate)]="currentRate" class="rating"></ngb-rating>

<pre>Rate: <b>{{currentRate}}</b></pre>
</div></div>
<mat-divider></mat-divider>
<div class="row">
  <div class="col-md-12 ">
  <p class="heading">  Shiping Address</p>
  
</div>
  <div class="col-md-9">
    <ng-container *ngFor="let key of Object.keys(order.address)let i=index">
    <p class="address" *ngIf="i<1">{{key}}: {{order.address[key]}}</p>
    <p class="address1" *ngIf="i==1"> ,{{order.address[key]}}</p>
  </ng-container>
  </div>
</div><mat-divider></mat-divider>
<div class="row">
  <div class="col-md-12 ">
  <p class="heading">  Billing Address</p>
</div>
  <div class="col-md-9">
    <ng-container *ngFor="let key of Object.keys(order.address)let i=index">
      <p class="address" *ngIf="i<1">{{key}}: {{order.address[key]}}</p>
      <p class="address1" *ngIf="i==1"> ,{{order.address[key]}}</p>
    </ng-container>
  </div>
</div>
  </mat-card>
</div> 
<div class="col-md-8">

  <mat-card class="card1">
      <h2>Order Detail</h2>
      <mat-divider></mat-divider>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

        <!-- Name Column -->
       
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef mat-sort-header >IMAGE </th>
          <td mat-cell *matCellDef="let element" role="gridcell"><ng-container *ngIf="element.image.url!='' && element.image.url!=undefined;else Dishimage">
             <img src="{{element.image.url}}" class="img1"></ng-container> 
             <ng-template #Dishimage>
              <img src="../../../assets/img/dish.jpg" class="img1">
             </ng-template>        
        </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header >NAME </th>
          <td mat-cell *matCellDef="let element" role="gridcell">{{element.name}}
            <br>
           <ng-container *ngIf="element.attribute_name">{{element.attribute_name}}:<ng-container *ngFor="let i of element.attribute;let isLast=last">{{i.value}}{{isLast ? '' : ','}}</ng-container></ng-container> 
         
        
        </td>
        </ng-container>
      
        <!-- Quantity Column -->
        <ng-container matColumnDef="Quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>QUANTITY </th>
          <td mat-cell *matCellDef="let element" role="gridcell"> 
          <ng-container *ngIf="!element.attribute.length;else attributeQuantity">{{element.multiple}}</ng-container>
          <ng-template #attributeQuantity><ng-container *ngFor="let i of element.attribute;let isLast=last">{{i.quantity}}{{isLast?'':','}}
            </ng-container>
          </ng-template>
          </td>
        </ng-container>
        <!-- Retail price Column -->
        <ng-container matColumnDef="sellPrice">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>RETAIL PRICE </th>
            <td mat-cell *matCellDef="let element" role="gridcell">
              <ng-container *ngIf="!element.attribute.length;else attributeRetailPrice">{{element.retail_price}}</ng-container>
              <ng-template #attributeRetailPrice><ng-container *ngFor="let i of element.attribute;let isLast=last">{{i.retail_price}}{{isLast?'':','}}
                </ng-container>
              </ng-template>
            </td>
          </ng-container>
        <!-- price Column -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>PRICE</th>
          <td mat-cell *matCellDef="let element" role="gridcell">
            <ng-container *ngIf="!element.attribute.length;else AttributePrice">{{element.price}}</ng-container>
            <ng-template #AttributePrice><ng-container *ngFor="let i of element.attribute;let isLast=last">{{i.price}}{{isLast?'':','}}
              </ng-container>
            </ng-template>
          </td>
        </ng-container>
      
        <!-- Total Column -->
        <ng-container matColumnDef="Total">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> TOTAL </th>
          <td mat-cell *matCellDef="let element" role="gridcell">  
            <ng-container *ngIf="!element.attribute.length;else AttributeTotal">{{element.retail_price * element.multiple}}</ng-container>
            <ng-template #AttributeTotal>{{getPrice(element)}} 
            </ng-template></td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-divider></mat-divider>
      <br><br>
      <div class="row">

  <div class="col-md-7 colt">

    <div class="col-sm-12">
    <p class="heading">  Bill Details</p>
 
  </div>
  <mat-divider></mat-divider>
  <div class="row">
  <div class="col-sm-6">
  <p class="amount"> Itemtotal</p>

</div>
<div class="col-sm-6">
  <p class="proc">{{order.itemTotal}}</p>

</div></div>

<div class="col-sm-12">
  <p class="heading1">Shiping Detail</p>
</div>
<div class="row">
<div class="col-sm-8">
  <p class="dpname">
  <img src="https://cdn.kalingatv.com/wp-content/uploads/2020/05/biryani.jpg" class=" db">
  <span>Delivery Boy
  </span>

  </p>
</div>
<div class="col-sm-4">
<p class="proc1">$17</p>

</div></div>
<div class="col-sm-12">
  <p class="heading1">Taxes Detail</p>
</div>
<div class="row">
  <div class="col-sm-6">
  <p class="amount" style="color: black;"> GST (included)</p>

</div>

<div class="col-sm-6">
  <p class="proc">(included)</p>

</div>
 
</div>
<mat-divider></mat-divider>

    <div class="row">
      <div class="col-md-6">
        <div class="col-sm-12">
  <p class="heading"> Total Pay</p>
  </div></div>

  <div class="col-md-6">
 
  <p class="proc">${{order.totalPrice}}</p>
</div>
  
</div></div>

<div class="col-md-5">
  <p class="heading"> Note</p>
  <mat-divider></mat-divider>

  <mat-form-field  class="my-form-field" appearance = "standard">
    
    <textarea class="textarea" matInput placeholder="Note"  name="terms_description" [(ngModel)]="order.note"  class="date1" [disabled]="order.orderStatus=='Delivered'"></textarea>
</mat-form-field>
<div class="text-center">
<button mat-raised-button class="btn" (click)="editOrderDetail()" [disabled]="order.orderStatus=='Delivered'">CHANGE NOTE</button></div>
</div>
</div>
<div class="row">
  </div>
</mat-card>
</div>
</div> 
<!-- <mat-card class="card2">
<div class="row">
   <div class="col-md-12">
    <mat-card-title> USER DETAIL</mat-card-title>
<mat-divider></mat-divider>

</div>
<div class="col-md-12 clo1">
    {{order.customers.fullname}}

</div>
<div class="col-md-12 clo2">
    {{order.customers.email}}

    <a (click)="viewProfile()">View Profile</a><br></div>
    
</div>
  
<mat-divider></mat-divider>
<div class="row">
    <div class="col-md-12">
        <br>
     <mat-card-title> DELIVERY ADDRESS</mat-card-title>
 <mat-divider></mat-divider>
 
 </div>
 <div class="col-md-10 clo3">
    {{order.address}}

 
 </div>
 </div>
 <mat-divider></mat-divider>
 <div class="row">
    <div class="col-md-12">
        <br>
     <mat-card-title> PAYMENT DETAILS</mat-card-title>
 <mat-divider></mat-divider>
 
 </div>
 
 </div>
 <br>
 <div class="row">
     <div class="col-md-4">
        <div class="col-sm-12"> Total Amount
        </div>
        <div class="col-sm-12 aba"> 
        </div>
     </div>
     <div class="col-md-4">

        <div class="col-sm-12"> Voucher Amount
        </div>
        <div class="col-sm-12 aba"> {{order.voucher.amount}}
        </div>
     </div>
     <div class="col-md-4">
      
        <div class="col-sm-12"> Paid Amount
        </div>
        <div class="col-sm-12 aba"> {{order.totalPrice}}
        </div>
     </div>
 </div>
</mat-card>
 -->

<!-- <mat-card class="card3">
    <mat-card-header>
        <mat-card-title>NOTES</mat-card-title>
    </mat-card-header><mat-divider></mat-divider>
    <mat-card-footer>
        <mat-card-subtitle>No Notes From User</mat-card-subtitle>
    </mat-card-footer>
</mat-card> -->
<!-- <div class="main">       <h2>INVOICE #89789</h2>
</div> 
<form>
   
<div class="row box">
      <div class="row">
          <div class="col-md-6 ">
            <mat-form-field class="example-full-width" style="    display: contents;">
              <mat-label>Issue Date</mat-label>
              <input readonly matInput [matDatepicker]="picker" (click)="picker.open()" name="date" [(ngModel)]="order.order_date" value="" disabled class="date1" >
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              
            </mat-form-field>
      </div>
      

  
      <div class="col-md-6 ">
        <mat-form-field class="example-full-width" style="    display: contents;">
          <mat-label>Due Date</mat-label>
          <input readonly matInput [matDatepicker]="picker1" (click)="picker1.open()" name="date" [(ngModel)]="order.order_date" value="" disabled class="date1" >
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          
        </mat-form-field>
  </div>  
    <div class="col-md-12">
      <mat-form-field class="example-full-width">
        <mat-label>Notes</mat-label>
        <textarea class="textarea" matInput placeholder="Ex. It makes me feel..." name="terms_description" [(ngModel)]="order.comment" disabled class="date1"></textarea>
      </mat-form-field>
    </div>
  </div>
 </div>
  </form>
  <mat-divider></mat-divider>
  <div class="row">
  
    <div class="col-md-6">
      <br>
      <p>Contact</p>
    </div>
  </div> -->